import {h} from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'
import Tooltip from './Tooltip'
import Icon from '../assets'
import globals from '../../utils/globals'

export enum ShareButtonType {
  TWITTER = "twitter",
  FACEBOOK = "facebook",
  LINKEDIN = "linkedin",
  WHATSAPP = "whatsapp"
}

interface ShareButton {
  type: ShareButtonType,
  linkTitle: string,
  title: string,
  content: string
}

export default ({ buttons } : { buttons: ShareButton[] }) => <div class='social-sharing'><Tooltip
  withArrow
  trigger={<div class='share-button btn--secondary'><Icon size={20} icon='share' /></div>}
  tooltipMessage={<div class='share-container'>{ buttons.map((button: ShareButton) => {
    if (button.type === ShareButtonType.LINKEDIN) {
      return <a title={button.linkTitle} class='btn btn--icon btn--linkedin qa-button-linkedin' target='_blank'
                href={`http://www.linkedin.com/shareArticle?mini=true&url=${encodeURI(window.location.href)}&title=${encodeURI(button.title)}&summary=${encodeURI(button.content)}`}>
        <Phrase p='linkedin.share'/>
      </a>
    }
    if (button.type === ShareButtonType.FACEBOOK) {
      return <a title={button.linkTitle} class='btn btn--icon btn--facebook qa-button-facebook' target='_blank'
                href={facebookShareUrl({title: button.title})}>
        <Phrase p='facebook.share' />
      </a>
    }
    if (button.type === ShareButtonType.TWITTER) {
      return <a title={button.linkTitle} class='btn btn--icon btn--twitter qa-button-twitter' target='_blank'
                href={`http://twitter.com/intent/tweet?text=${encodeURI(window.location.href)}`}>
        <Phrase p='twitter.share' />
      </a>
    }
    if (button.type === ShareButtonType.WHATSAPP) {
      return <a title={button.linkTitle}
                class='btn btn--icon btn--whatsapp icon icon--whatsapp is-hidden-mobile-up'
                href={`whatsapp://send?text=${encodeURI(window.location.href)}`}>
        <Phrase p='whatsapp.share' />
      </a>
    }
    return null
  })}</div>}
/></div>

const facebookShareUrl = ({ title, url }: { title: string, url?: string } ) => {
  const urlToShare = url || window.location.href
  const appId = globals('facebookAppId');
  if (appId !== '') {
    return `https://www.facebook.com/dialog/feed?app_id=${encodeURI(appId.toString())}&display=popup&caption=${encodeURI(title)}&link=${encodeURI(urlToShare)}`
  }
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURI(urlToShare)}`
}
